import { TenantByPortalHostDocument, type TenantByPortalHostQuery } from "~/gql/queries/portal.generated";
import publicClient from "~/services/publicClient";

const fetchTenantIdByPortalHost = async (host: string): Promise<string | null> => {
	const response = await publicClient.request<TenantByPortalHostQuery>(TenantByPortalHostDocument.toString(), {
		host
	});
	return response.tenantByPortalHost?.tenantId ?? null;
};

export default fetchTenantIdByPortalHost;
